import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'
import DashboardView from './views/DashboardView.vue'
import LoginView from './views/LoginView.vue'
import MonitorView from './views/MonitorView.vue'
import OrderDetailView from './views/OrderDetailView.vue'
import OrdersView from './views/OrdersView.vue'
import TakeoffApplicationsView from './views/TakeoffApplicationsView.vue'
import { hasToken } from './api/client'

/**
 * 监管端路由(S-11;S-50 加第四页:综合监控)。
 *
 * 三条已实现的链路各一个页面:登录、订单只读列表(+详情)、数据大屏;
 * S-50 按 Y-32 的真实页面清单补上第三项「综合监控」(/monitor,v2 · G5 全屏大屏)。
 * 除此之外这个端**没有别的页面**,而且短期不会有:视频直播、三天回放、起降场画面
 * 整块不在本期(L0-06 搁置、M-09 排除),BLK-02 解除后才重开 ——
 * 画板里那些对不上真实页面的导航项(G5 顶栏的七个页签 / 侧栏的八个导航)
 * 按 Y-32 不渲染,逐条登记在 design-copy.json 的 _notRequired 里。
 *
 * ═══ 没有令牌就跳登录页 ═══
 *
 * 这个前置守卫是**体验**,不是权限:真正的权限在服务端(全局只读守卫 +
 * GovTokenGuard),这里只负责把没令牌的人送到登录页并记住他原本要去哪。
 * 与运营端同一条纪律 —— 前端里的任何判断都不该被当成安全边界。
 */
const routes: RouteRecordRaw[] = [
  { path: '/', redirect: '/dashboard' },
  { path: '/login', name: 'login', component: LoginView, meta: { public: true } },
  { path: '/dashboard', name: 'dashboard', component: DashboardView },
  { path: '/orders', name: 'orders', component: OrdersView },
  { path: '/orders/:orderNo', name: 'order-detail', component: OrderDetailView, props: true },
  { path: '/takeoff-applications', name: 'takeoff-applications', component: TakeoffApplicationsView },
  { path: '/monitor', name: 'monitor', component: MonitorView },
]

export const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach((to) => {
  if (to.meta.public) return true
  if (hasToken()) return true
  return { path: '/login', query: { redirect: to.fullPath } }
})
